(() => {
  // escape hatch
  if (!document.body.classList.contains("single-event")) return;

  const db = firebase.database(),
    blockMap = db.ref(`${WP.envKey}/event${WP.pageID}/blocks`),
    sidebarMap = db.ref(`${WP.envKey}/event${WP.pageID}/sidebars`);

  // blocks
  blockMap.on("value", (snapshot) => {
    for (const [uuid, { enabled }] of Object.entries(snapshot.val() || {})) {
      const block = document.querySelector(`[data-block-uuid="${uuid}"]`);
      if (block) block.dataset.enabled = enabled ? 1 : 0;
    }
  });

  // sidebar tabs
  if (document.querySelector(".event-sidebar")) {
    let init = false;
    sidebarMap.on("value", (snapshot) => {
      for (const [name, enabled] of Object.entries(snapshot.val() || {})) {
        const sidebar = document.getElementById(`tab-${name}`),
          navItem = document
            .querySelector(`[href="#tab-${name}"]`)
            ?.closest(".event-sidebar-tab");

        if (sidebar) sidebar.dataset.enabled = enabled ? 1 : 0;
        if (navItem) navItem.dataset.enabled = enabled ? 1 : 0;
      }

      // if current active tab got disabled, click over to the first enabled tab
      // ? connection with firebase must already be initialized,
      // ? because this is only meant to pick up existing visible tabs that are
      // ? actively disabled by an admin, never onload
      if (init) {
        const activeTab = document
          .querySelector(".active.event-sidebar-tab-link")
          ?.closest(".event-sidebar-tab");
        if (activeTab && activeTab.dataset.enabled !== "1") {
          const firstEnabledTabLink = document.querySelector(
            '.event-sidebar-tab[data-enabled="1"] a'
          );
          if (firstEnabledTabLink) firstEnabledTabLink.click();
        }
      } else {
        init = true;
      }
    });
  }
})();
